import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface IAlert {
  type: 'alert' | 'warn' | 'error';
  title: string;
  message: string;
  primaryText?: string;
  primaryCallback?: any;
  secondaryText?: string;
  secondaryCallback?: any;
  messageHtml?: string;
  maxWidth?:string;
  okButtonColor?:string;
  cancelButtonColor?:string;
  btnSolid?:boolean;
  showJustify?: boolean;
  justifyTitle?: string;
  justifyPlaceholder?: string;
}

const Dialog$: BehaviorSubject<any> = new BehaviorSubject('initialize');

export function show(
  type: 'alert' | 'warn' | 'error',
  title: string,
  message: string,
  primaryText?: string,
  primaryCallback?: any,
  secondaryText?: string,
  secondaryCallback?: any,
  messageHtml?:string,
  maxWidth?:string,
  okButtonColor?:string,
  cancelButtonColor?:string,
  btnSolid?:boolean,
  showJustify?: boolean,
  justifyTitle?: string,
  justifyPlaceholder?: string,
): void {
  Dialog$.next({
    type,
    title,
    message,
    secondaryText,
    secondaryCallback,
    primaryText,
    primaryCallback,
    messageHtml,
    maxWidth,
    okButtonColor,
    cancelButtonColor,
    btnSolid,
    showJustify,
    justifyTitle,
    justifyPlaceholder,
  });
}

export function close(): void {
  Dialog$.next('initialize');
}

export function get(): Observable<any> {
  return Dialog$.pipe(filter((val) => val !== 'initialize'));
}
